<template>
  <div class="edit-search">
    <div class="edit-shop-header">
      <h3>报名设置</h3>
      <div class="edit-shop-delete">

      </div>
    </div>
    <div class="edit-shop-content">
      <section class="edit-shop-search">
        <el-form :model="content" label-width="100px" size="small">
          <el-form-item label="背景色：">
            <el-color-picker v-model="content.bgcolor" size="small"></el-color-picker>
          </el-form-item>
          <el-row>
            <el-col :span="10">
              <el-form-item label="按钮文字：">
                <el-input type="text" v-model="content.btnTxt" placeholder="请输入" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="按钮背景色：">
                <el-color-picker v-model="content.btnBgcolor" size="small"></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="按钮文字色：">
                <el-color-picker v-model="content.btncolor" size="small"></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="标题：">
                <el-input type="text" v-model="content.title" placeholder="请输入" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="标题大小(px)：">
                <el-input-number v-model="content.titleSize" :min="12" :max="100" size="small" label="请输入" controls-position="right"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="标题颜色：">
                <el-color-picker v-model="content.titleColor" size="small"></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      index: {
        type: Number,
        default: 0
      },
      content: {}
    },
    computed: {

    },
    data () {
      return {
        'type': 'search'
      }
    },
    watch: {
      'content': {
        handler (newValue, oldValue) {
          this.contentChange()
        },
        deep: true
      }
    },
    methods: {
      contentChange () {
        this.$emit('message', this.content);
      },
      deleteComs () {
        this.$emit('delete', this.index);
      }
    }
  }
</script>

<style scoped>
  .edit-shop-search {
    background-color: #fff;
  }
</style>
